import { parseISO, isAfter, startOfDay, format } from 'date-fns'

export function formatDateLabel(
  startDateStr: string,
  endDateStr: string
): string {
  const today = startOfDay(new Date())
  const startDate = startOfDay(parseISO(startDateStr))
  const endDate = startOfDay(parseISO(endDateStr))

  const formattedEnd = format(endDate, 'dd/MM/yy')

  if (isAfter(startDate, today)) {
    const formattedStart = format(startDate, 'dd/MM/yy')
    return `${formattedStart} - ${formattedEnd}`
  } else {
    return `UNTIL ${formattedEnd}`
  }
}
